<template>
	<el-dialog title="" :visible.sync="thirdVisible" width="720px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
	    :close-on-click-modal='false' :append-to-body="true">
		<div class="singupdialogcenter">
			<div class="title">
				您已成功提交入会申请！
			</div>
			<div class="textbox" v-if="materialsFlag&&!score">
				请完成机构能力测评！
			</div>
			<div class="textbox" v-else>
				您的入会申请已经提交，请等待审核！
			</div>
			<div class="formBtnBox">
				<el-button type="primary" @click="offmodalFn" class="submitBtn">好的</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
	props: ['isShow', 'flagObj'],
	data() {
		return {
			thirdVisible: true,
			islogin: sessionStorage.getItem('token'),
			userId: JSON.parse(sessionStorage.getItem('userInfo')).userId || "",
			materialsFlag: '',
			score: ""
		}
	},
	mounted() {
		this.getAuditFn()
	},
	methods: {
		getAuditFn() {
			httpService.getCorpInfoOther(this.userId).then(res => {
				if (res.code == 200) {
					this.materialsFlag = res.result.materials2
					this.score = res.result.score
				}
			})
		},
		// 关闭表单
		offmodalFn() {
			if (this.materialsFlag && !this.score) {
				sessionStorage.setItem('clickMenu', '能力指数测评')
				this.$router.push('/assessment-institutions');
			} else {
				this.$emit('thirdshowModal', false)
				if (!this.isCustom) this.$destroy() // 销毁当前组件
				if (this.islogin) {
					this.$router.push("/account-center/centerpage");
				} else {
					this.$router.push("/");
				}
			}
		},
	}
}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		.title {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 46px;
		}
		.textbox {
			font-size: 16px;
			line-height: 30px;
			color: #666666;
			margin-bottom: 120px;
		}

		.formBtnBox {
			display: flex;
			fill-opacity: row;
			justify-content: center;
			cursor: pointer;
			.submitBtn {
				width: 152px;
				height: 40px;
				background: #349cff;
				margin: 0 20px;
				cursor: pointer;
			}
		}
	}
}
</style>


